import { useRevenueSupportingApplicationsMetrics } from '../../hooks/useRevenueSupportingApplicationsMetrics';
import { useDirectlySupportedRevenueApplicationsMetrics } from '../../hooks/useDirectlySupportedRevenueApplicationsMetrics';
import { MetricCard } from '../MetricCard';

type RevenueSupportingApplicationsWidgetProps = {
  locationUuid: string;
};

export const RevenueSupportingApplicationsWidget = ({
  locationUuid,
}: RevenueSupportingApplicationsWidgetProps) => {
  const { totalApplications, loading: totalLoading } =
    useRevenueSupportingApplicationsMetrics(locationUuid);
  const { directlySupportedApplications, loading: directlyLoading } =
    useDirectlySupportedRevenueApplicationsMetrics(locationUuid);

  const isLoading = totalLoading || directlyLoading;
  const notSupportingRevenue =
    totalApplications - directlySupportedApplications;

  return (
    <>
      <MetricCard
        title="Revenue Supporting Applications"
        tooltipText="Number of IT Applications tied to revenue."
        topMetric={{
          value: directlySupportedApplications ?? 0,
          description: 'Applications Directly Support Revenue',
        }}
        bottomMetric={{
          value: notSupportingRevenue ?? 0,
          description: 'Applications Do Not Directly Support Revenue',
        }}
        onViewClick={() => {}}
        isLoading={isLoading}
        showViewButton={false}
      />
    </>
  );
};
